import React, { useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import "../style/VariacionPorPaisYMes.css"; // Importamos el CSS actualizado

const VariacionPorPaisYMes = () => {
  const [chartOptions, setChartOptions] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://marketbusters.pro/chart/graficos/fetch_variaciones_por_pais_mes.php"
        );
        const data = await response.json();

        console.log("Datos recibidos:", data);

        // Agrupamos los datos por país y mes
        const groupedData = data.reduce((acc, item) => {
          const { pais, mes, total_variacion } = item;
          const valor = parseInt(total_variacion.replace(/,/g, ""), 10);

          if (!acc[mes]) acc[mes] = {};
          acc[mes][pais] = valor;
          return acc;
        }, {});

        console.log("Datos agrupados por mes:", groupedData);

        // Obtenemos los países y los meses únicos
        const countries = [...new Set(data.map((item) => item.pais))];
        const months = Object.keys(groupedData).sort();

        // Creamos series para cada mes
        const series = months.map((mes) => ({
          name: mes,
          type: "bar",
          data: countries.map((pais) => groupedData[mes][pais] || 0),
        }));

        // Configuración del gráfico con ajustes
        const options = {
          backgroundColor: "#1E1E1E", // Fondo del gráfico
          title: {
            text: "Variación por País y Mes", // Título del gráfico
            left: "center",
            top: "5%", // Ajustamos el margen superior del título
            textStyle: {
              color: "#ffffff", // Color del texto
              fontSize: 18,
            },
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          legend: {
            top: "12%", // Movemos la leyenda hacia abajo
            textStyle: {
              color: "#ffffff",
            },
            data: months,
          },
          grid: {
            left: "3%",
            right: "4%",
            top: "25%", // Dejamos espacio para el título y la leyenda
            bottom: "3%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            data: countries,
            axisLine: {
              lineStyle: {
                color: "#ffffff",
              },
            },
            axisLabel: {
              color: "#ffffff",
            },
          },
          yAxis: {
            type: "value",
            axisLine: {
              lineStyle: {
                color: "#ffffff",
              },
            },
            axisLabel: {
              color: "#ffffff",
            },
            splitLine: {
              lineStyle: {
                color: "#555555",
              },
            },
          },
          series: series,
          color: [
            "#5470C6",
            "#91CC75",
            "#FAC858",
            "#EE6666",
            "#73C0DE",
            "#3BA272",
            "#FC8452",
            "#9A60B4",
          ],
        };

        setChartOptions(options);
        setLoading(false);
      } catch (error) {
        console.error("Error al obtener los datos:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <p className="grafico-title">Cargando datos...</p>;
  }

  if (!chartOptions) {
    return <p className="grafico-title">No se pudieron cargar los datos.</p>;
  }

  return (
    <div className="grafico-container">
      <ReactECharts
        option={chartOptions}
        style={{
          height: "100%",
          width: "100%",
        }}
        theme="dark"
      />
    </div>
  );
};

export default VariacionPorPaisYMes;
